var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"secure"},[_c('main',{staticClass:"main-container"},[_c('router-view')],1),_c('sidebar'),_c('topbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }